import { Controller } from '@hotwired/stimulus';

/**
 * Moves keyboard focus to the element it's attached to (the step heading) on
 * load. In a multi-step flow each step is a full page navigation, so this lands
 * screen-reader and keyboard users on the step title — past the global nav —
 * and has the step announced instead of leaving focus at the top of the document
 * (WCAG 2.4.3 Focus Order).
 *
 * Apply to the <h1> of non-OTP auth steps. OTP steps intentionally focus their
 * first digit box (see otp_input_controller), so don't add this there.
 */
export default class extends Controller {
  connect(): void {
    const el = this.element as HTMLElement;
    if (!el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex', '-1');
    }
    el.focus({ preventScroll: true });
  }
}
